<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6.40015 2.80078L9.16938 2.80078L18.4001 12.4008L9.16938 22.0008H6.40015"
            stroke="#45494D"
            stroke-width="1.5"
        />
        <path
            d="M6.40015 7.59961H7.69245L12.0001 12.3996L7.69245 17.1996H6.40015"
            stroke="#45494D"
            stroke-width="1.5"
        />
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
